/* unplugin-vue-components disabled */import script from "./wxMiniGameDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./wxMiniGameDetail.vue?vue&type=script&setup=true&lang=ts"

import "./wxMiniGameDetail.vue?vue&type=style&index=0&id=8f3e036e&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f3e036e"]])

export default __exports__